import React from 'react'

/* Atoms */
import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <>
      <Box
        sx={{
          p: 2,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Skeleton variant="circular" height={48} width={48} />
          <Skeleton variant="rounded" height={48} sx={{ flex: 1 }} />
        </Box>
        <Skeleton variant="rounded" height={48} width={'100%'} />
        <Skeleton variant="rounded" height={48} width={'100%'} />
        <Skeleton variant="rounded" height={48} width={'100%'} />
      </Box>
    </>
  )
}

Loading.displayName = 'Loading'

export default Loading
